export default __webpack_public_path__ + "static/media/DNo.28-2.adfe7327.jpg";